export const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  white: {
    primary: '#000',
    secondary: '#FDFEFE',
  },
};

export interface EventColor {
  primary: string;
  secondary: string;
}
